module.exports = __webpack_public_path__ + "img/symbol_7.570616c7.png";